import { Button, Typography } from "matsuri-ui"
import dayjs from "dayjs"
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded"
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded"
import { SupplySummaryList } from "./SupplySummaryList"
import {
    DoneBody,
    DoneIcon,
    ItemList,
    Main,
    ReportedAt,
    SummaryBar
} from "./styled"
import { MobileLayout, displayName } from "./utils"
import { Header } from "@/components/Header/Header"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"
import { ReportFooter } from "@/components/Footer/ReportFooter"
import { RoomSupplyReportResponse } from "@/hooks/useRoomSupply"
import { useTranslation } from "@/hooks/useTranslation"

interface Props {
    report: RoomSupplyReportResponse
    layout: MobileLayout
    onNext: () => void
    // 今回送信した完了画面ではなく、既に報告済みだった場合の表示に切り替える
    alreadyReported?: boolean
}

export const CompletedView = ({
    report,
    layout,
    onNext,
    alreadyReported = false
}: Props) => {
    const { t } = useTranslation()

    return (
        <Main style={layout.rootProps.style}>
            <Header {...layout.headerProps}>
                <MobileAppHeader
                    title={
                        <Typography variant="h4">
                            {t("備品の残量報告")}
                        </Typography>
                    }
                />
            </Header>

            <div {...layout.bodyProps}>
                <DoneBody>
                    <DoneIcon>
                        <CheckCircleRoundedIcon style={{ fontSize: 44 }} />
                    </DoneIcon>
                    <Typography variant="h4" bolder>
                        {alreadyReported
                            ? t("この清掃は報告済みです")
                            : t("不足品目を報告しました")}
                    </Typography>
                    <ReportedAt>
                        <ScheduleRoundedIcon style={{ fontSize: 14 }} />
                        {t("報告時刻")}{" "}
                        {dayjs.unix(report.reportedAt).format("M/D HH:mm")}
                    </ReportedAt>
                    <Typography color="textSecondary">
                        {t("担当チームが内容を確認し、備品を手配します。")}
                    </Typography>
                </DoneBody>

                <ItemList>
                    <SummaryBar>{t("報告した内容")}</SummaryBar>
                    <SupplySummaryList
                        entries={report.items.map(item => ({
                            key: item.itemId,
                            name: displayName(item),
                            quantity: item.quantity
                        }))}
                    />
                </ItemList>
            </div>

            <ReportFooter {...layout.footerProps}>
                <Button
                    variant="filled"
                    color="primary"
                    fullWidth
                    onClick={onNext}
                >
                    {t("次へ進む")}
                </Button>
            </ReportFooter>
        </Main>
    )
}
